import request from '@/api/request';

export function checkImei (imei) {
  return request({
    url: '/device/checkimei',
    method: 'get',
    params: {
      imei
    }
  });
}


// WEBPACK FOOTER //
// ./src/api/device.js